import axios from 'axios';

const getAllResultTypes = (cancelToken, config) => {
  return axios.get('/api/results', { cancelToken, ...config });
};

const getAllResults = (config) => {
  return axios.get('/api/results/all', config);
};

const createResultType = (newResultType) => {
  return axios.post('/api/results/saveResultType', newResultType);
};

const editResultType = (data) => {
  return axios.put('/api/results/editResultType', data);
};

const deleteResultType = (id, config) => {
  return axios.delete(`/api/results/deleteResultType/${id}`, config);
};

const createResult = async (newResult) => {
  const result = await axios.post('/api/results/configureScoringResult', newResult);
  await updateResultTypeMaxScore(newResult.resultTypeId);
  return result;
};

const editResult = async (data, config) => {
  const updatedResult = await axios.put('/api/results/configureScoringResult', data, config);
  await updateResultTypeMaxScore(data.resultTypeId, config);
  return updatedResult;
};

const deleteResult = async (id, resultTypeId, config) => {
  const deletedResult = await axios.delete(`/api/results/configureScoringResult/${id}`, config);
  await updateResultTypeMaxScore(resultTypeId, config);
  return deletedResult;
};

const saveScores = (scores, config, scoresToRemove) => {
  if (scores && scores.length === 0 && scoresToRemove && scoresToRemove.length === 0) {
    return [];
  }
  return axios.post('/api/results/saveScores', { scores:scores, scoresToRemove: scoresToRemove} , config, );
};

const getAssignedPeerReviews = (config) => {
  return axios.get('/api/results/getAssignedPeerReviews', config);
};

const updateResultTypeMaxScore = (resultTypeId, config) => {
  return axios.put(`/api/results/resultTypeMaxScore/${resultTypeId}`, undefined, config);
};

const getScoringInfo = (scoreType, config) => {
  return axios.get(`/api/results/scoring_info?scoreTypeName=${scoreType}`, config);
};

const bulkUploadScores = (data) => {
  return axios.put('/api/results/upload_scores', data);
};

const saveResultTypeScoringRecommendationToggle = (value, backendId) => {
  return axios.post('/api/results/save-result-type-scoring-recommendation-toggle', { value, backendId });
};

export {
  getAllResultTypes,
  createResultType,
  editResultType,
  deleteResultType,
  createResult,
  editResult,
  deleteResult,
  saveScores,
  getAllResults,
  getAssignedPeerReviews,
  getScoringInfo,
  bulkUploadScores,
  saveResultTypeScoringRecommendationToggle,
};
